import { useContext, useEffect, useMemo, useRef, useState } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callautopopulate } from "../../../services/callautopop";
import { useNavigate } from "react-router-dom";
import { DateObject } from "react-multi-date-picker";
import { useCommon } from "../../Common/useCommon";

export const useGitRequestList = ({fromReport}) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [loader, setLoader] = useState(false);
    const tagRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [showRequestPopup, setShowRequestPopup] = useState(false)
    const [filterValues, setFilterValues] = useState({ hoveredRange: [new DateObject().subtract(8, "days"), new DateObject().add(0, "days"),] });
    const [dropDownOption, setDropDownOption] = useState({});
    const [editData, setEditData] = useState({});
    const [showApprovePopup, setShowApprovePopup] = useState(false);
    const { getValuePermission } = useCommon();
    const [approval, setApproval] = useState({
        status: '',
        data: "",
        from_date: null,
        to_date: null,
        selectedRadio: ""
    });
    const navigate = useNavigate();
    const [headerChecked, setHeaderChecked] = useState(false);

    const rowClassRules = {
        "new-request": (params) => { return (params.data.is_new_repo) }
    }
    const columnDefs = [
        {
            field: "checkbox",
            headerName: "",
            headerComponent: () => {
                return (
                    <div className="w100">
                        <input type="checkbox" onChange={(e) => { handleSelectAll(e) }} checked={headerChecked} />
                    </div>
                )
            },
            width: 40,
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellStyle: { textAlign: "center" },
            suppressHeaderMenuButton: true,
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) && <input type="checkbox" checked={params.data.is_checked} onChange={(e) => handleSelectAll(e, params)} />
                        }

                    </div>

                )
            }
        },
        {
            field: "edit",
            headerName: "Edit",
            width: 40,
            cellStyle: { textAlign: "center" },
            headerClass: "ag-text-center",
            hide: filterValues?.status?.request_status_id !== _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                const isNewRepo = params.data.is_new_repo;
                let allowEdit = false;
                if (isNewRepo && params?.data?.approver_user_code === dropDownOption?.userCode) {
                    allowEdit = true;
                } else if (!isNewRepo && (params?.data?.approver_user_code === dropDownOption?.userCode || params?.data?.requested_user_code === dropDownOption?.userCode)) {
                    allowEdit = true;
                }
                return <div>{allowEdit && params.data?.request_status_id === pendingId ?
                    <div style={{ cursor: "pointer" }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" onClick={() => { setShowRequestPopup(true); setEditData(params) }} /></div> :
                    <></>}</div>
            }
        },
        {
            field: "request_status_name",
            headerName: "Status",
            width: 50,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                const approveId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_id;
                const rejectedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_rejected" })?.request_status_id;
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                const grantId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_grant" })?.request_status_id;
                const partialId = -1;
                return (
                    <div style={{ cursor: "pointer", fontSize: "large" }}>
                        {params.data.request_status_id === approveId && <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "green" }} />}
                        {params.data.request_status_id === rejectedId && <FontAwesomeIcon icon="fa-solid fa-circle-xmark" style={{ color: "red" }} />}
                        {params.data.request_status_id === pendingId && <FontAwesomeIcon icon="fa-solid fa-clock" style={{ color: "#d4d404" }} />}
                        {params.data.request_status_id === partialId && <FontAwesomeIcon icon="fa-solid fa-thumbs-up" style={{ color: "green" }} />}
                        {params.data.request_status_id === grantId && <FontAwesomeIcon icon="fa-solid fa-check-double" style={{ color: "green" }} />}
                    </div>
                )
            }
        },
        {
            field: "request_status_name",
            headerName: "Action",
            width: 150,
            cellStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                return (
                    <div>
                        {
                            (params?.data?.approver_user_code === dropDownOption?.userCode && params.data.request_status_id === pendingId) &&
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        onChange={(e) => { setShowApprovePopup(true); setApproval((prevState) => ({ ...prevState, data: params?.data?.git_repo_request_id, status: e.target.value, selectedRadio: "" })) }
                                        }
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        onChange={(e) => { handleRequest(e.target.value, params?.data?.git_repo_request_id) }
                                        }
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: "request_type_name",
            headerName: "Type",
            width: 60,
            headerClass: "text-left",
        },
        {
            field: "project_name",
            headerName: "Project",
            width: 120,
            headerClass: "text-left",
        },
        {
            field: "repo_group_name",
            headerName: "Git Group",
            width: 110,
            headerClass: "text-left",
            cellRenderer: (params) => {
                return (
                    <div title={params.data.repo_group_name}>{params.data.repo_group_name}</div>
                )
            }
        },
        {
            field: "repo_name",
            headerName: "Request Info",
            width: 160,
            headerClass: "text-left",
            cellRenderer: (params) => {
                return (
                    <div title={params.data.repo_name}>{params.data.repo_name}</div>
                )
            }
        },
        {
            field: "request_role_type",
            headerName: "Role",
            width: 80,
            headerClass: "text-left",
            cellRenderer: (params) => {
                return (
                    <div>{params.data.is_new_repo ? "" : params.data.request_role_type}</div>
                )
            }
        },
        {
            field: "request_by",
            headerName: "Request By",
            width: 120,
            headerClass: "text-left",
        },
        {
            field: "request_to",
            headerName: "Request To",
            width: 120,
            headerClass: "text-left",
        },
        {
            field: "reason",
            headerName: "Reason",
            minWidth: 260,
            headerClass: "text-left",
            cellRenderer: function (params) {
                return (
                    <div title={params?.data?.reason}>
                        {params?.data?.reason}
                    </div>
                );
            },

        },
        {
            headerName: "Apply Date", field: "apply_datetime", width: 130, cellStyle: { textAlign: "center" }, headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.apply_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Approve Date",
            field: "approve_datetime",
            width: 130,
            hide: filterValues?.status?.request_status_id === _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellStyle: { textAlign: "center" },
            headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.approve_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            headerName: "Expiry Date",
            field: "expiry_datetime",
            width: 130,
            hide: filterValues?.status?.request_status_id === _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id,
            cellStyle: { textAlign: "center" },
            headerClass: "help-desk-grid-header",
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.expiry_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },

    ]

    useEffect(() => {
        callautopopulate("request_status", "all_users", "projects", "user_info", "git_roles").then((res) => {
            setDropDownOption({
                statusOptions: res?.request_status,
                users: _.sortBy(res?.all_users,"user_display_name"),
                projects: res?.projects?.sort((a, b) => a.project_name.localeCompare(b.project_name)),
                userCode: res?.user_info?.[0]?.user_code,
                roleOpts: _.sortBy(res?.body?.data?.git_roles, "request_role_name"),
                apiCall: true
            })
            setFilterValues((prev) => ({ ...prev, status: res?.request_status?.[0] }));
        }).catch((error) => {
            console.error("error", error)
        })

    }, [])

    useEffect(() => {
        ((dropDownOption?.apiCall) && !fromReport) && filterValues.apiCall && getRequestedData();
    }, [dropDownOption?.apiCall,filterValues?.apiCall])


    const handleSelectAll = (e, rowdata) => {
        const data = [...rowData];
        if (rowdata) {
            data[rowdata.node.rowIndex]["is_checked"] = e?.target?.checked;
            setRowData(data);
        } else {
            data.forEach((item) => {
                if (item.approver_user_code === dropDownOption?.userCode) {
                    item.is_checked = e?.target?.checked;;
                }
            });
            setHeaderChecked(!headerChecked)
            setRowData(data);
        }

    }

    const handleStatusChange = (e) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e.target.value),
        });
        setFilterValues((prev) => ({ ...prev, status: data }));
        getRequestedData(parseInt(e.target.value))
    };


    const getRequestedData = async (status, filters) => {
        try {
            setRowData([]);
            setLoader(true);
            const payload = {
                request_type_id: '',
                "from_date": filters?.from_date ? dateConvert(filters?.from_date, "iso-string") : ((filterValues?.hoveredRange && filterValues?.hoveredRange[0] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[0]) : '') || "",
                "to_date": filters?.to_date ? dateConvert(filters?.to_date, "iso-string") : ((filterValues?.hoveredRange && filterValues?.hoveredRange[1] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[1]) : '') || "",
                "project_ids": _.pluck(filters?.projects || filterValues?.projects, "project_id").toString() || "",      
                request_type_roles_id: _.pluck(filterValues?.role, "request_type_roles_id").toString(),
                "request_status_id": status ? status : filterValues?.status?.request_status_id,
                users: _.pluck(filterValues?.all_users, "user_code").toString()
            };
            const res = await services.getInvokeRemote("POST", Urls("GETREQUESTDETAILS"), payload);
            if (res?.StatusCode === 202 || res?.status === 202) {
                showError("Error", res.body.errorMessage);
                setLoader(false);
            } else if (res.body.data) {
                setLoader(false);
                setRowData(_.sortBy(res.body.data.git_details, "requested_user_name"));
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            setLoader(false);
            console.error("Error", error)
            error?.response?.data?.errorMessage && showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setLoader(false);
        }
    }

    // handle the git approve & reject request 
    const handleRequest = async (status, id) => {
        try {
            if ((approval?.status === "is_approved" && (approval?.data?.length <= 0 || !approval?.data)) || (status === "is_rejected" && (!id || id?.length <= 0))) {
                showInfo("Info", "Please select a request to reject");
                return;
            }
            const requestStatus = _.findWhere(dropDownOption?.statusOptions, { request_status_key: status || approval.status })
            const payload = {
                "git_repo_request_ids": id ? id?.toString() : approval?.data?.toString(),
                "request_status_id": requestStatus?.request_status_id,
                "expiry_datetime": approval?.expiryDate
            }
            const res = await services.getInvokeRemote("POST", Urls("APPROVEREQUEST"), payload)
            if (res.body.data) {
                showSuccess('Success', res.body.message)
                setShowApprovePopup(false)
                getRequestedData()
                setApproval((prevState) => ({ ...prevState, status: '', to_date: null, from_date: null, expiryDate: null, selectedRadio: "" }))
            }
            else {
                showError("Error", res.body.errorMessage);
            }

        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    return useMemo(() => ({
        loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, navigate, handleRequest, editData, setEditData, approval, setApproval, rowClassRules, showInfo
    }), [loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, showApprovePopup, setShowApprovePopup, navigate, handleRequest, editData, setEditData, approval, setApproval, rowClassRules, showInfo]);
}